export default {
  parkingFines: state => state.parkingFines,
  selectedParkingFine: state => state.selectedParkingFine,
  parkingFineImages: state => state.parkingFineImages,
  availableReasons: state => state.availableReasons,
  parkingStatusCheckLogs: state => state.parkingStatusCheckLogs,
  parkingFineReportingTasks: state => state.parkingFineReportingTasks,
  selectedParkingFineReportingTask: state =>
    state.selectedParkingFineReportingTask,
  enforcementOfficers: state => state.enforcementOfficers,
  selectedEnforcementOfficer: state => state.selectedEnforcementOfficer,
  enforcementPlaceGroups: state => state.enforcementPlaceGroups
}
